import { render, staticRenderFns } from "./ToxicologyReport.vue?vue&type=template&id=697c61c4"
import script from "./ToxicologyReport.vue?vue&type=script&lang=js"
export * from "./ToxicologyReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports